(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["header-marquee"]) return;
  try {
    
 const createApp = (data) => new Vue(data);
const ComponentCountdown = {
    name: 'component-countdown',
    delimiters: ['${' , '}'],
    props: {
        countdown: {required: true, type: [String, Number, Date]},
        require_days: {required: false, type: Boolean},
    },
    computed: {
        distance() {
            if(this.now > this.countdown_date) return 0;
            return this.countdown_date - this.now;
        },
        days() {
            return Math.floor(this.distance / (1000 * 60 * 60 * 24));
        },
        hours() {
            const calc_hours = Math.floor((this.distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            if(this.require_days) return this.add_zero(calc_hours);
            return this.add_zero(calc_hours + this.days * 24);
        },
        minutes() {
            return this.add_zero(Math.floor((this.distance % (1000 * 60 * 60)) / (1000 * 60)));
        },
        seconds() {
            return this.add_zero(Math.floor((this.distance % (1000 * 60)) / 1000));
        },
    },
    data() {
        return {
            now: new Date().getTime(),
            countdown_date: new Date(this.countdown).getTime(),
        }
    },
    methods: {
        add_zero(value) {
            return value.toString().length == 1 ? "0" + value : value;
        }
    },
    created() {
    },
    mounted() {
      
console.log('checkingssss')
        if(this.countdown_date - this.now !== 0){
            setInterval( () => this.now = new Date().getTime(), 1000);
        }
    },
    template:  /*html*/
    `
    <div class="component-countdown pamysoft">
        <div class="component-countdown__days-container component-countdown__value-container" v-if="require_days">
            <div class="component-countdown__days component-countdown__value" v-html="days"></div>
            <div class="component-countdown__unit">d</div>
        </div>
        <div class="component-countdown__hours-container component-countdown__value-container" v-if="hours !== '00'">
            <div class="component-countdown__hours component-countdown__value" v-html="hours"></div>
            <div class="component-countdown__unit">h</div>
        </div>
        <div class="component-countdown__minutes-container component-countdown__value-container">
            <div class="component-countdown__minutes component-countdown__value" v-html="minutes"></div>
            <div class="component-countdown__unit">m</div>
        </div>
        <div class="component-countdown__seconds-container component-countdown__value-container">
            <div class="component-countdown__seconds component-countdown__value" v-html="seconds"></div>
            <div class="component-countdown__unit">s</div>
        </div>
    </div>
    `
}
  
const ComponentMarquee = {
        name: 'component-marquee', 
        delimiters: ['${' , '}'],
        props: {
           reverse: { required: false, type: Boolean, default: () => false },
           scroll: { required: false, type: Boolean, default: () => true },
           speed: { required: false, type: Number, default: 50},
        },
        components: {
        },
        data() {
            return {
                marquee_number: 1,
                active: false,
            }
        },
        methods: {
            calculate_marquee_number() {
                const container_width = this.$refs.marquee_container.clientWidth;
                const item_width = this.$refs.marquee_item11[0].clientWidth || 200; 
                // const font_size = getComputedStyle(document.documentElement).fontSize || '13px';
              const font_size = '13px';
                const number_font_size = Number.parseInt(font_size.replace('px', ''))
                this.$refs.marquee_container.style.setProperty('--marquee-animation-duration', `${Math.floor(container_width / this.speed)}s`);
                this.active = true;
                return Math.max(Math.ceil(container_width / (item_width + number_font_size)), 2);
            },
        },
        mounted() {
            setTimeout( () => this.marquee_number = this.calculate_marquee_number(), 500)
            
        },
        template: /*html*/
        `
        <div ref="marquee_container" class="component-marquee-container">
            <div class="component-marquee" :class="[reverse && 'reverse', scroll && 'scroll', active && 'active']" :key='i + "marquee-container"'  v-for='i in 2'>
                <div class="component-marquee-item":key='"marquee-item" + i + marquee_number + index' :ref='"marquee_item" + i + index' v-for='index in marquee_number' >
                    <slot/>
                </div>
            </div>
        </div>
        `
    }
  
  // header promo bar
const HeaderPromo = {
  name: 'header-promo',
  delimiters: ['${' , '}'],
  props: {
      text_before_countdown: {required: true, type: String},
      text_after_countdown: {required: true, type: String},
      speed: {required: true, type: Number},
      count_to_date: {required: true, type: String},
  },
  data(){
  },
  created(){;
  },
  mounted(){   
    console.log('component-countdownssss')
    setTimeout(() => this.active = true, 250);    
  },
  components: {
    ComponentMarquee,
    ComponentCountdown,
  },
  computed: {
    local_discount_code(){
      return this.discount.code ? this.discount.code : false;
    },
  },
  methods: {
  },
  template: /*html*/
  `
    <div class="header-promo" :class="'code_applied'">
      <transition name="fast-fade" mode="out-in">
        <a class="header-promo__marquee-container" href="/">
          <component-marquee :speed="speed">
            <div class="component-marquee-item__marquee-item">
              <div class="textleft" v-html="text_before_countdown"></div>
              <component-countdown :countdown="count_to_date" :require_days="true"></component-countdown>
              <div class="textright" v-html="text_after_countdown"></div>
            </div>
          </component-marquee>
        </a>
      </transition>
    </div>
  `,
};

const vue_header = createApp({
  name: `Vue Header`,
  el: "#vue-header",
  delimiters: ['${' , '}'],
  components: {
      HeaderPromo,
      ComponentCountdown,
  },

});


  } catch(e) { console.error(e); }
})();

})();
